export default __webpack_public_path__ + "static/media/322.68f890f5.jpg";